import { EDS_BASE_URL } from 'config';
import { EDS_SITE_NAV } from 'config/constants';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { useEffect } from 'react';

export const STYLE_ID = 'external-styles';
export const EXTERNAL_STYLE_PATH = '/styles/external-styles.css';
export const SCRIPT_ID = 'external-script';
export const EXTERNAL_SCRIPT_PATH = '/scripts/external-scripts.js';

const useEdsExternalAssets = () => {
  const { isReady, isEnabled } = useFeatureFlag(EDS_SITE_NAV);

  useEffect(() => {
    if (!isReady || !isEnabled) {
      return;
    }

    const baseUrl = EDS_BASE_URL;

    if (!baseUrl) {
      return;
    }

    if (!document.getElementById(STYLE_ID)) {
      const link = document.createElement('link');
      link.id = STYLE_ID;
      link.rel = 'stylesheet';
      link.href = `${baseUrl}${EXTERNAL_STYLE_PATH}`;
      document.head.appendChild(link);
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.src = `${baseUrl}${EXTERNAL_SCRIPT_PATH}`;
      script.type = 'module';
      script.defer = true;
      document.body.appendChild(script);
    }

    return () => {
      const style = document.getElementById(STYLE_ID);
      const script = document.getElementById(SCRIPT_ID);

      if (style) style.remove();
      if (script) script.remove();
    };
  }, [isReady, isEnabled]);
};

export default useEdsExternalAssets;
